module.exports = __webpack_public_path__ + "static/pricing_hero-7fb0c6de82798ba20e6012a3a4df7d43.png";